import { Route, Routes, Navigate } from "react-router-dom";
import Authorization from "./pages/Authorization";
import EmployeesTable from "./pages/EmployeesTable";
import NotFound from "./pages/NotFound";
import { useIsAuthenticated } from "react-auth-kit";
import Cookies from 'js-cookie';

const App = () => {
  const isAuthenticated = useIsAuthenticated();

  console.log("cookie", Cookies.get('_auth_storage'))

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated() ? <EmployeesTable /> : <Navigate to="/login" />
        }
      />
      <Route path="/login" element={<Authorization />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
export default App;
